"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const react_use_1 = require("react-use");
const useScrollDirection_1 = require("@src/hooks/useScrollDirection");
// TODO: move to a global modal component
const OfferNotificationSubscriptionModal_1 = require("@src/components/pages/offers/modules/OfferNotificationSubscriptionModal");
const react_router_dom_1 = require("react-router-dom");
const header_menu_context_1 = require("@src/context/header-menu-context");
const HeaderMenu_1 = require("./HeaderMenu");
const StyledHeader = styled_components_1.default.header `
	height: ${props => props.theme.size.headerHeight}px;
	color: ${props => props.theme.color.white};
	display: flex;
	z-index: 100;
	position: relative;
	margin: 0 0 20px 0;
	width: 100%;
	// chrome fux up our transitions on initial load
	// this is a temporary fix
	${props => props.mounted &&
    (0, styled_components_1.css) `
			transition: all 0.2s ease;
		`}
	transform: translateY(0);
	margin: 0 0 -${props => props.theme.size.headerHeight}px 0;
	&:after {
		content: '';
		position: fixed;
		top: 0;
		left: 0;
		background: url('/media/images/background-gradient.jpg');
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center 90%;
		width: 100%;
		height: 100%;
		z-index: -1;
		opacity: 0;
		transform: translateY(-100%);
		transition: all 0.2s ease;
	}

	${props => !props.withHero &&
    (0, styled_components_1.css) `
			background: url('/media/images/background-gradient.jpg');
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center 90%;
		`}

	${props => props.scrolled &&
    (0, styled_components_1.css) `
			position: fixed;
			transform: translateY(-100%);
			transition: none;
		`}

	${props => props.scrolledFromTop &&
    (0, styled_components_1.css) `
			transition: all 0.2s ease;
		`}

	${props => props.sticky &&
    (0, styled_components_1.css) `
			position: fixed;
			transform: translateY(0);
			transition: all 0.2s ease;
			&:after {
				opacity: 1;
				transform: translateY(0);
			}
		`}
`;
const Header = props => {
    const theme = (0, styled_components_1.useTheme)();
    const { isMenuSticked, setIsMenuSticked } = (0, header_menu_context_1.useHeaderMenuContextValue)();
    const [isSubscriptionModalOpen, setIsSubscriptionModalOpen] = react_1.default.useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = react_1.default.useState(false);
    const [mounted, setMounted] = react_1.default.useState(false);
    react_1.default.useEffect(() => {
        setMounted(true);
    }, []);
    const scrollDirection = (0, useScrollDirection_1.useScrollDirection)({ thresholdPixels: 0 });
    const { y: topOffset } = (0, react_use_1.useWindowScroll)();
    const location = (0, react_router_dom_1.useLocation)();
    react_1.default.useEffect(() => {
        setMobileMenuOpen(false);
    }, [location]);
    react_1.default.useEffect(() => {
        if (scrollDirection === 'up') {
            if (topOffset > 0 && !isMenuSticked) {
                setIsMenuSticked(true);
            }
            else if (topOffset === 0) {
                setIsMenuSticked(false);
            }
        }
        else if (scrollDirection === 'down') {
            if (topOffset > theme.size.headerHeight) {
                setIsMenuSticked(false);
            }
        }
        if (mobileMenuOpen) {
            setMobileMenuOpen(false);
        }
    }, [topOffset]);
    return ((0, jsx_runtime_1.jsxs)(StyledHeader, { ...props.navigation, sticky: isMenuSticked, scrolled: topOffset > theme.size.headerHeight, scrolledFromTop: topOffset > theme.size.headerHeight * 2, mounted: mounted, children: [(0, jsx_runtime_1.jsx)(HeaderMenu_1.HeaderMenu, { isMenuSticked: isMenuSticked, mobileMenuOpen: mobileMenuOpen, setIsSubscriptionModalOpen: setIsSubscriptionModalOpen, setMobileMenuOpen: setMobileMenuOpen }), (0, jsx_runtime_1.jsx)(OfferNotificationSubscriptionModal_1.OfferNotificationSubscriptionModal, { isOpen: isSubscriptionModalOpen, setIsOpen: setIsSubscriptionModalOpen })] }));
};
exports.default = Header;
